import { action, makeObservable, observable } from 'mobx';

const STORAGE_KEY = 'llm_fast_mode';

function readStoredValue(): boolean {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);

    return stored === null ? true : stored === 'true';
  } catch {
    return true;
  }
}

export class FastModeStore {
  enabled = readStoredValue();

  constructor() {
    makeObservable(this, {
      enabled: observable,
      toggle: action.bound,
    });
  }

  toggle(): void {
    this.enabled = !this.enabled;

    try {
      window.localStorage.setItem(STORAGE_KEY, String(this.enabled));
    } catch {
      /* no-op */
    }
  }
}
